module.exports = __webpack_public_path__ + "images/kihnu/favicon-16x16.png";